import { render, staticRenderFns } from "./MeasurementsByRole.vue?vue&type=template&id=128fac80&scoped=true&"
import script from "./MeasurementsByRole.vue?vue&type=script&lang=js&"
export * from "./MeasurementsByRole.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementsByRole.vue?vue&type=style&index=0&id=128fac80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128fac80",
  null
  
)

export default component.exports